import { AppModificationFragment } from '@willow/graphql-iso/src/app';

import { assertNever } from './assertNever';

export const formatModification = (modification: AppModificationFragment) => {
  switch (modification.__typename) {
    case 'PrincipalModification':
      return 'Principal Modification';
    case 'FlexModification':
      return 'Flex Modification';
    case 'LoanRecast':
      return 'Loan Recast';
    default:
      assertNever(modification);
  }
};
